import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import dataCenterImg from "../../../assets/focus areas/datalabs.webp";
import mobilityImg from "../../../assets/focus areas/mobility.webp";
import healthcareImg from "../../../assets/focus areas/healthcare.webp";
import programsImg from "../../../assets/focus areas/programs.webp";
import translationImg from "../../../assets/focus areas/translation.webp";
import startupImg from "../../../assets/focus areas/startup.webp";
import { Link } from "react-router-dom";
import "./focusarea.css";
import { FaArrowRightLong } from "react-icons/fa6";

export const FocusArea = () => {

  return (
    <>
      <Container>
        <h2 className="fw-bold text-center mt-5 py-2" data-aos="fade-right"> Focus Areas </h2>
        <Row className="justify-content-center">
          <Col xs={12} md={6} lg={4} data-aos="fade-right">
            <div className="card-sld1">
              <img
                src={dataCenterImg}
                className="img-fluid focusAreaCardImage"
                alt=""
              />

              <div className="card-bottom-content position-relative ">
                <Row className="justify-content-center align-items-center">
                  <Col
                    xs={10}
                    className="d-flex justify-content-between align-items-center p-0"
                  >
                    <div className="card-con">
                    <a
                        href="https://india-data.org/"
                        target="__blank"
                        className="text-decoration-none"
                      >
                      <h6 className="fw-bold text-dark text-dark">India Data</h6>
                      </a>
                    </div>
                    <div className="rd-more">
                      <a
                        href="https://india-data.org/"
                        target="__blank"
                        className="text-white"
                      >
                        <FaArrowRightLong style={{ fontSize: "22px" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} data-aos="fade-down">
            <div className="card-sld1">
              <img
                src={mobilityImg}
                className="img-fluid focusAreaCardImage"
                alt=""
              />

              <div className="card-bottom-content position-relative ">
                <Row className="justify-content-center align-items-center">
                  <Col
                    xs={10}
                    className="d-flex justify-content-between align-items-center p-0"
                  >
                    <div className="card-con">
                    <a
                        href="https://mobility.iiit.ac.in/"
                        target="__blank"
                        className="text-decoration-none"
                      >
                      <h6 className="fw-bold text-dark">Mobility</h6>
                      </a>
                    </div>
                    <div className="rd-more">
                      <a
                        href="https://mobility.iiit.ac.in/"
                        target="__blank"
                        className="text-white"
                      >
                        <FaArrowRightLong style={{ fontSize: "22px" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} data-aos="fade-right">
            <div className="card-sld1">
              <img
                src={healthcareImg}
                className="img-fluid focusAreaCardImage"
                alt=""
              />

              <div className="card-bottom-content position-relative ">
                <Row className="justify-content-center align-items-center">
                  <Col
                    xs={10}
                    className="d-flex justify-content-between align-items-center p-0"
                  >
                    <div className="card-con">
                    <a
                        href="https://hai.iiit.ac.in/"
                        target="__blank"
                        className="text-decoration-none"
                      >
                      <h6 className="fw-bold text-dark">Healthcare</h6>
                      </a>
                    </div>
                    <div className="rd-more">
                      <a
                        href="https://hai.iiit.ac.in/"
                        target="__blank"
                        className="text-white"
                      >
                        <FaArrowRightLong style={{ fontSize: "22px" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} md={6} lg={4} data-aos="fade-right">
            <div className="card-sld1">
              <img
                src={programsImg}
                className="img-fluid focusAreaCardImage"
                alt=""
              />

              <div className="card-bottom-content position-relative ">
                <Row className="justify-content-center align-items-center">
                  <Col
                    xs={10}
                    className="d-flex justify-content-between align-items-center p-0"
                  >
                    <div className="card-con">
                    <a
                        href="https://ihub-data.ai/"
                        target="__blank"
                        className="text-decoration-none"
                      >
                      <h6 className="fw-bold text-dark">Programs</h6>
                      </a>
                    </div>
                    <div className="rd-more">
                      <a
                        href="https://ihub-data.ai/"
                        target="__blank"
                        className="text-white"
                      >
                        <FaArrowRightLong style={{ fontSize: "22px" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} data-aos="fade-up">
            <div className="card-sld1">
              <img
                src={translationImg}
                className="img-fluid focusAreaCardImage"
                alt=""
              />

              <div className="card-bottom-content position-relative ">
                <Row className="justify-content-center align-items-center">
                  <Col
                    xs={10}
                    className="d-flex justify-content-between align-items-center p-0"
                  >
                    <div className="card-con">
                    <a
                        href="https://www.inai.ai/"
                        target="__blank"
                        className="text-decoration-none"
                      >
                      <h6 className="fw-bold text-dark">Translation</h6>
                      </a>
                    </div>
                    <div className="rd-more">
                      <a
                        href="https://www.inai.ai/"
                        target="__blank"
                        className="text-white"
                      >
                        <FaArrowRightLong style={{ fontSize: "22px" }} />
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} data-aos="fade-left">
            <div className="card-sld1">
              <img
                src={startupImg}
                className="img-fluid focusAreaCardImage"
                alt=""
              />

              <div className="card-bottom-content position-relative ">
                <Row className="justify-content-center align-items-center">
                  <Col
                    xs={10}
                    className="d-flex justify-content-between align-items-center p-0"
                  >
                    <div className="card-con">
                      <Link className="nav-link text-white" to="/startups">
                      <h6 className="fw-bold text-dark">Startups</h6>
                      </Link>
                    </div>
                    <div className="rd-more">
                      <Link className="nav-link text-white" to="/startups">
                        <FaArrowRightLong style={{ fontSize: "22px" }} />
                      </Link>

                      {/* </a> */}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
